@if (userStore.initialized() && userStore.commune() && userStore.isLoggedIn()) {
  <app-authenticated-dashboard></app-authenticated-dashboard>
} @else if (!userStore.initialized()) {
  <app-dashboard-skeleton />
}

<app-tool-overlay></app-tool-overlay>
